<template>
  <div class="cp-portal">
    <Transition name="cp-fade">
      <div
        v-if="value"
        class="cp-popup"
        :style="{
          left:   pos.x + 'px',
          top:    pos.y + 'px',
          width:  size.w + 'px',
          height: size.h + 'px',
        }"
        ref="popupEl"
      >

        <!-- ══ HEADER ══════════════════════════════════════════════ -->
        <div class="cp-header" @mousedown="startDrag">
          <div class="cp-header__left">
            <div class="cp-header__icon-wrap">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <span class="cp-header__title">Clientes</span>
            <span v-if="meta" class="cp-header__count">{{ meta.total }}</span>
          </div>
          <button class="cp-close" @click="$emit('input', false)">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <!-- ══ SEARCH ═══════════════════════════════════════════════ -->
        <div class="cp-search-wrap">
          <svg class="cp-search-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8">
            <circle cx="6.5" cy="6.5" r="5"/><path d="M10.5 10.5l3.5 3.5" stroke-linecap="round"/>
          </svg>
          <input
            class="cp-search"
            v-model="query"
            placeholder="Nombre, email, teléfono, ID…"
            @input="onInput"
            ref="searchEl"
          />
          <Transition name="cp-fade-quick">
            <button v-if="query" class="cp-search-clear" @click="query = ''; doFetch()">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </Transition>
        </div>

        <!-- ══ BODY ══════════════════════════════════════════════════ -->
        <div class="cp-body">
          <Transition name="cp-slide" mode="out-in">

            <!-- ── DETALLE ──────────────────────────────────────── -->
            <div v-if="detail" key="detail" class="cp-detail-wrap">
              <button class="cp-back" @click="detail = null">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
                Volver a la lista
              </button>

              <div class="cp-detail">
                <!-- Avatar hero -->
                <div class="cp-detail__hero">
                  <div class="cp-detail__avatar">{{ initials(detail.nombre, detail.apellido) }}</div>
                  <div class="cp-detail__hero-info">
                    <div class="cp-detail__name">{{ detail.nombre }} {{ detail.apellido }}</div>
                    <div class="cp-detail__id">#{{ detail.idusuario }}</div>
                    <div class="cp-detail__since">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                      </svg>
                      Cliente desde {{ formatDate(detail.fecha_registro) }}
                    </div>
                  </div>
                </div>

                <!-- Info rows -->
                <div class="cp-detail__rows">
                  <div class="cp-detail__row">
                    <span class="cp-detail__row-icon">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    </span>
                    <span class="cp-detail__row-lbl">ID</span>
                    <span class="cp-detail__row-val"><span class="cp-result">#{{ detail.idusuario }}</span></span>
                  </div>
                  <div class="cp-detail__row">
                    <span class="cp-detail__row-icon">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    </span>
                    <span class="cp-detail__row-lbl">Nombre</span>
                    <span class="cp-detail__row-val"><span class="cp-result">{{ detail.nombre || 'Ninguno' }}</span></span>
                  </div>
                  <div class="cp-detail__row">
                    <span class="cp-detail__row-icon">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    </span>
                    <span class="cp-detail__row-lbl">Apellido</span>
                    <span class="cp-detail__row-val"><span class="cp-result">{{ detail.apellido || 'Ninguno' }}</span></span>
                  </div>
                  <div class="cp-detail__row">
                    <span class="cp-detail__row-icon">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                    </span>
                    <span class="cp-detail__row-lbl">Correo</span>
                    <span class="cp-detail__row-val"><span class="cp-result">{{ detail.correo || 'Ninguno' }}</span></span>
                  </div>
                  <div class="cp-detail__row">
                    <span class="cp-detail__row-icon">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
                    </span>
                    <span class="cp-detail__row-lbl">Teléfono</span>
                    <span class="cp-detail__row-val"><span class="cp-result">{{ detail.telefono || 'Ninguno' }}</span></span>
                  </div>
                  <div class="cp-detail__row">
                    <span class="cp-detail__row-icon">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                    </span>
                    <span class="cp-detail__row-lbl">Tipo</span>
                    <span class="cp-detail__row-val cp-detail__row-val--badge" :class="'cp-badge--' + (detail.tipo || 'unknown')"><span class="cp-result cp-result--badge">{{ detail.tipo || 'Ninguno' }}</span></span>
                  </div>
                </div>

                <!-- Datos bancarios -->
                <div class="cp-bank-sep">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                  <span>Datos bancarios</span>
                </div>

                <template v-if="detail.bank_account">
                  <div class="cp-detail__rows cp-detail__rows--bank">
                    <div class="cp-detail__row">
                      <span class="cp-detail__row-icon">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                      </span>
                      <span class="cp-detail__row-lbl">Banco</span>
                      <span class="cp-detail__row-val"><span class="cp-result">{{ detail.bank_account.bank_name || 'Ninguno' }}</span></span>
                    </div>
                    <div class="cp-detail__row">
                      <span class="cp-detail__row-icon">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                      </span>
                      <span class="cp-detail__row-lbl">Titular</span>
                      <span class="cp-detail__row-val"><span class="cp-result">{{ [detail.bank_account.first_name, detail.bank_account.last_name].filter(Boolean).join(' ') || 'Ninguno' }}</span></span>
                    </div>
                    <div class="cp-detail__row">
                      <span class="cp-detail__row-icon">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
                      </span>
                      <span class="cp-detail__row-lbl">Nro. Cuenta</span>
                      <span class="cp-detail__row-val"><span class="cp-result">{{ detail.bank_account.bank_account_number || 'Ninguno' }}</span></span>
                    </div>
                    <div v-if="detail.bank_account.branch_code" class="cp-detail__row">
                      <span class="cp-detail__row-icon">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 010 14.14"/><path d="M4.93 4.93a10 10 0 000 14.14"/></svg>
                      </span>
                      <span class="cp-detail__row-lbl">Sucursal</span>
                      <span class="cp-detail__row-val"><span class="cp-result">{{ detail.bank_account.branch_code }}</span></span>
                    </div>
                    <div v-if="detail.bank_account.government_id" class="cp-detail__row">
                      <span class="cp-detail__row-icon">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>
                      </span>
                      <span class="cp-detail__row-lbl">RUT/ID</span>
                      <span class="cp-detail__row-val"><span class="cp-result">{{ detail.bank_account.government_id }}</span></span>
                    </div>
                  </div>
                </template>
                <div v-else class="cp-bank-empty">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/>
                  </svg>
                  <span>Sin datos bancarios registrados</span>
                </div>
              </div>
            </div>

            <!-- ── LISTA ────────────────────────────────────────── -->
            <div v-else key="list" class="cp-list-wrap">
              <div v-if="loading" class="cp-state">
                <span class="cp-spinner"></span>
                <span>Buscando…</span>
              </div>
              <div v-else-if="error" class="cp-state cp-state--error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {{ error }}
              </div>
              <div v-else-if="items.length === 0" class="cp-state">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.25">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
                Sin resultados
              </div>
              <div v-else class="cp-list">
                <div
                  v-for="(c, i) in items"
                  :key="c.idusuario"
                  class="cp-item"
                  :style="{ animationDelay: i * 30 + 'ms' }"
                  @click="openDetail(c.idusuario)"
                >
                  <div class="cp-item__avatar">{{ initials(c.nombre, c.apellido) }}</div>
                  <div class="cp-item__body">
                    <div class="cp-item__top">
                      <span class="cp-item__name">{{ c.nombre }} {{ c.apellido }}</span>
                      <span class="cp-item__id">#{{ c.idusuario }}</span>
                    </div>
                    <div class="cp-item__email">{{ c.correo }}</div>
                    <div class="cp-item__phone">{{ c.telefono }}</div>
                  </div>
                  <svg class="cp-item__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </div>
              </div>

              <div v-if="meta && meta.last_page > 1" class="cp-pagination">
                <button :disabled="meta.current_page === 1" @click="changePage(meta.current_page - 1)">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>
                </button>
                <span>{{ meta.current_page }} <span class="cp-pag-sep">/</span> {{ meta.last_page }}</span>
                <button :disabled="meta.current_page === meta.last_page" @click="changePage(meta.current_page + 1)">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
                </button>
              </div>
            </div>

          </Transition>
        </div>

        <!-- ══ RESIZE HANDLES ════════════════════════════════════════ -->
        <!-- Bordes -->
        <div class="cp-resize cp-resize--e"  @mousedown.stop="startResize($event, 'e')"></div>
        <div class="cp-resize cp-resize--s"  @mousedown.stop="startResize($event, 's')"></div>
        <div class="cp-resize cp-resize--w"  @mousedown.stop="startResize($event, 'w')"></div>
        <div class="cp-resize cp-resize--n"  @mousedown.stop="startResize($event, 'n')"></div>
        <!-- Esquinas -->
        <div class="cp-resize cp-resize--se" @mousedown.stop="startResize($event, 'se')"></div>
        <div class="cp-resize cp-resize--sw" @mousedown.stop="startResize($event, 'sw')"></div>
        <div class="cp-resize cp-resize--ne" @mousedown.stop="startResize($event, 'ne')"></div>
        <div class="cp-resize cp-resize--nw" @mousedown.stop="startResize($event, 'nw')"></div>

      </div>
    </Transition>
  </div>
</template>

<script>
import apiUrls from '@/new-constants/apiUrls'
export default {
  name: 'ClientesPopup',
  props: {
    value: { type: Boolean, default: false },
    baseUrl:    { type: String,  default: apiUrls.base }
  },
  data() {
    return {
      items: [],
      meta: null,
      loading: false,
      error: null,
      query: '',
      page: 1,
      detail: null,
      size: { w: 480, h: 560 },
      pos: { x: 0, y: 0 },
      _dragging: false,
      _ox: 0,
      _oy: 0,
      _resizing: false,
      _debTimer: null
    }
  },
  methods: {
    MIN_W() { return 320 },
    MIN_H() { return 300 },
    MAX_W() { return window.innerWidth - 16 },
    MAX_H() { return window.innerHeight - 16 },
    clampPos(x, y, w, h) {
      const vw = window.innerWidth
      const vh = window.innerHeight
      return { x: Math.min(Math.max(x, 0), vw - w), y: Math.min(Math.max(y, 0), vh - h) }
    },
    startDrag(e) {
      if (e.target.closest('button, .cp-resize')) return
      this._dragging = true
      this._ox = e.clientX - this.pos.x
      this._oy = e.clientY - this.pos.y
      document.addEventListener('mousemove', this._onDrag)
      document.addEventListener('mouseup', this._stopDrag)
    },
    _onDrag(e) {
      if (!this._dragging) return
      const clamped = this.clampPos(e.clientX - this._ox, e.clientY - this._oy, this.size.w, this.size.h)
      this.pos = clamped
    },
    _stopDrag() {
      this._dragging = false
      document.removeEventListener('mousemove', this._onDrag)
      document.removeEventListener('mouseup', this._stopDrag)
    },
    startResize(e, dir) {
      e.preventDefault()
      this._resizing = true
      const startX = e.clientX, startY = e.clientY
      const startW = this.size.w, startH = this.size.h
      const startPX = this.pos.x, startPY = this.pos.y
      const onMove = (ev) => {
        if (!this._resizing) return
        const dx = ev.clientX - startX
        const dy = ev.clientY - startY
        let newW = startW, newH = startH, newX = startPX, newY = startPY
        if (dir.includes('e')) newW = startW + dx
        if (dir.includes('w')) { newW = startW - dx; newX = startPX + dx }
        if (dir.includes('s')) newH = startH + dy
        if (dir.includes('n')) { newH = startH - dy; newY = startPY + dy }
        newW = Math.min(Math.max(newW, this.MIN_W()), this.MAX_W())
        newH = Math.min(Math.max(newH, this.MIN_H()), this.MAX_H())
        if (dir.includes('w')) newX = startPX + startW - newW
        if (dir.includes('n')) newY = startPY + startH - newH
        const clamped = this.clampPos(newX, newY, newW, newH)
        this.size = { w: newW, h: newH }
        this.pos = clamped
      }
      const onUp = () => { this._resizing = false; document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp) }
      document.addEventListener('mousemove', onMove)
      document.addEventListener('mouseup', onUp)
    },
    onInput() {
      clearTimeout(this._debTimer)
      this._debTimer = setTimeout(() => {
        this.page = 1
        // Si el query es puramente numérico, buscar directamente por ID
        const q = this.query.trim()
        if (q && /^\d+$/.test(q)) {
          this.openDetail(Number(q))
        } else {
          this.doFetch()
        }
      }, 300)
    },
    async doFetch() {
      this.loading = true; this.error = null
      try {
        const params = new URLSearchParams({ page: this.page, limit: 15 })
        if (this.query && this.query.trim()) params.set('q', this.query.trim())
        const res = await window.fetch(`${apiUrls.adminClientes}?${params}`)
        const json = await res.json()
        this.items = json.data ? json.data : []
        this.meta  = json.meta ? json.meta : null
      } catch (e) { this.error = 'No se pudo conectar.' }
      finally { this.loading = false }
    },
    async openDetail(id) {
      this.loading = true
      try {
        const res = await window.fetch(`${apiUrls.adminClientes}/${id}`)
        const json = await res.json()
        this.detail = json.data
      } catch (e) { this.error = 'Error cargando detalle.' }
      finally { this.loading = false }
    },
    changePage(p) { this.page = p; this.doFetch() },
    initials(n, a) {
      const first = (n && n[0]) ? n[0] : ''
      const last = (a && a[0]) ? a[0] : ''
      return ((first + last).toUpperCase()) || '?'
    },
    formatDate(iso) { if (!iso) return '—'; return new Date(iso).toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' }) }
  },
  watch: {
    value(v) {
      if (v) {
        this.detail = null; this.query = ''; this.page = 1
        this.pos = this.clampPos(window.innerWidth / 2 - this.size.w / 2, window.innerHeight / 2 - this.size.h / 2, this.size.w, this.size.h)
        this.doFetch()
        this.$nextTick(() => { if (this.$refs.searchEl) this.$refs.searchEl.focus() })
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700;800;900&family=Geist+Mono:wght@400;500;600&family=Instrument+Serif:ital@0;1&display=swap');
/* ─── TOKENS ────────────────────────────────────── */
.cp-popup {
  --primary:        #FC7010;
  --primary-light:  rgba(252,112,16,0.10);
  --primary-dim:    rgba(252,112,16,0.22);
  --primary-dark:   #B84800;
  --bg:             #ffffff;
  --bg-1:           #FAFAF9;
  --bg-2:           #F4F3F0;
  --border:         #ECEAE4;
  --border-str:     #DBD9D2;
  --txt:            #0A0A0B;
  --txt-2:          #383840;
  --txt-3:          #6E6E76;
  --txt-4:          #A0A0A8;
  --red:            #dc2626;
}

/* ══ POPUP ══════════════════════════════════════════ */
.cp-popup {
  position: fixed;
  z-index: 1000;
  background: var(--bg);
  border: 1px solid var(--border-str);
  border-radius: 16px;
  box-shadow:
    0 4px 6px rgba(0,0,0,0.04),
    0 12px 32px rgba(0,0,0,0.10),
    0 32px 64px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Geist', 'DM Sans', 'Segoe UI', system-ui, sans-serif;
  font-size: 13px;
  color: var(--txt);
}

/* ══ RESIZE HANDLES ════════════════════════════════ */
.cp-resize { position: absolute; z-index: 10; }
.cp-resize--e  { right: 0;  top: 8px;  bottom: 8px; width: 6px;  cursor: ew-resize; }
.cp-resize--w  { left: 0;   top: 8px;  bottom: 8px; width: 6px;  cursor: ew-resize; }
.cp-resize--s  { bottom: 0; left: 8px; right: 8px;  height: 6px; cursor: ns-resize; }
.cp-resize--n  { top: 0;    left: 8px; right: 8px;  height: 6px; cursor: ns-resize; }
.cp-resize--se { right: 0;  bottom: 0; width: 12px; height: 12px; cursor: nwse-resize; }
.cp-resize--sw { left: 0;   bottom: 0; width: 12px; height: 12px; cursor: nesw-resize; }
.cp-resize--ne { right: 0;  top: 0;    width: 12px; height: 12px; cursor: nesw-resize; }
.cp-resize--nw { left: 0;   top: 0;    width: 12px; height: 12px; cursor: nwse-resize; }

/* ══ HEADER ════════════════════════════════════════ */
.cp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 14px;
  background: #ffffff;
  border-bottom: 1px solid var(--border);
  cursor: grab;
  user-select: none;
  flex-shrink: 0;
  position: relative;
}
.cp-header::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, var(--primary) 0%, transparent 60%);
}
.cp-header:active { cursor: grabbing; }
.cp-header__left { display: flex; align-items: center; gap: 9px; }
.cp-header__icon-wrap {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: var(--primary-light);
  border: 1px solid var(--primary-dim);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-dark);
  flex-shrink: 0;
  transition: background 0.15s;
}
.cp-header__title {
  font-weight: 800;
  font-size: 14px;
  color: var(--txt);
  letter-spacing: -0.2px;
}
.cp-header__count {
  font-size: 10.5px;
  font-weight: 700;
  color: var(--txt-3);
  background: #F4F3F0;
  border: 1px solid var(--border-str);
  padding: 2px 8px;
  border-radius: 20px;
}
.cp-close {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #FAFAF9;
  border: 1px solid var(--border-str);
  cursor: pointer;
  color: var(--txt-4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}
.cp-close:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: var(--red);
}

/* ══ SEARCH ════════════════════════════════════════ */
.cp-search-wrap {
  position: relative;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  background: var(--bg-1);
}
.cp-search-icon {
  position: absolute;
  left: 22px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  color: var(--txt-4);
  pointer-events: none;
}
.cp-search {
  width: 100%;
  background: #ffffff;
  border: 1px solid var(--border-str);
  border-radius: 9px;
  color: var(--txt);
  font-size: 12.5px;
  font-family: inherit;
  padding: 8px 28px 8px 28px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.cp-search::placeholder { color: var(--txt-4); }
.cp-search:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(252,112,16,0.12);
}
.cp-search-clear {
  position: absolute;
  right: 22px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background: #F4F3F0;
  border: none;
  cursor: pointer;
  color: var(--txt-3);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.12s;
}
.cp-search-clear:hover {
  background: var(--primary-light);
  color: var(--primary-dark);
}

/* ══ BODY ══════════════════════════════════════════ */
.cp-body {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.cp-list-wrap,
.cp-detail-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

/* ══ LISTA ═════════════════════════════════════════ */
.cp-list { flex: 1; overflow-y: auto; }
.cp-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  transition: background 0.15s ease, transform 0.1s ease;
  animation: cp-item-in 0.2s ease both;
}
@keyframes cp-item-in {
  from { opacity: 0; transform: translateY(5px); }
  to   { opacity: 1; transform: translateY(0); }
}
.cp-item:hover {
  background: #FAFAF9;
  transform: translateX(1px);
}
.cp-item:hover .cp-item__arrow {
  opacity: 1;
  transform: translateX(0);
}

.cp-item__avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(135deg, #FC7010 0%, #B91E7C 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
}
.cp-item__body  { flex: 1; min-width: 0; }
.cp-item__top   { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 2px; }
.cp-item__name  { font-weight: 700; font-size: 13px; color: var(--txt); }
.cp-item__id    { font-size: 10.5px; color: var(--txt-4); flex-shrink: 0; margin-left: 6px; }
.cp-item__email { font-size: 11.5px; color: var(--txt-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.cp-item__phone { font-size: 11px; color: var(--txt-4); }
.cp-item__arrow {
  color: var(--txt-4);
  flex-shrink: 0;
  opacity: 0;
  transform: translateX(-4px);
  transition: all 0.15s ease;
}

/* ══ PAGINACIÓN ════════════════════════════════════ */
.cp-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 9px;
  border-top: 1px solid var(--border);
  font-size: 12px;
  color: var(--txt-3);
  flex-shrink: 0;
  background: var(--bg-1);
}
.cp-pag-sep { opacity: 0.4; margin: 0 2px; }
.cp-pagination button {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid var(--border-str);
  color: var(--txt-3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}
.cp-pagination button:hover:not(:disabled) {
  border-color: var(--primary-dim);
  color: var(--primary-dark);
  background: var(--primary-light);
}
.cp-pagination button:disabled { opacity: 0.3; cursor: not-allowed; }

/* ══ DETALLE ═══════════════════════════════════════ */
.cp-back {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 14px;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-dark);
  background: var(--bg-1);
  border: none;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: background 0.15s;
  font-family: inherit;
  flex-shrink: 0;
}
.cp-back:hover { background: var(--primary-light); }

.cp-detail {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cp-detail__hero {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 14px;
  background: #FAFAF9;
  border: 1px solid var(--border-str);
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}
.cp-detail__hero::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary) 0%, transparent 65%);
  border-radius: 12px 12px 0 0;
}

.cp-detail__avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(135deg, #FC7010 0%, #B91E7C 100%);
  border: 2px solid #FFD4AE;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
}
.cp-detail__hero-info { flex: 1; }
.cp-detail__name {
  font-size: 15px;
  font-weight: 800;
  color: var(--txt);
  margin-bottom: 2px;
  letter-spacing: -0.2px;
}
.cp-detail__id {
  font-size: 11px;
  color: var(--txt-4);
  margin-bottom: 5px;
}
.cp-detail__since {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--txt-3);
}

.cp-detail__rows { display: flex; flex-direction: column; }
.cp-detail__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px solid var(--border);
  font-size: 12.5px;
}
.cp-detail__row:last-child { border-bottom: none; }
.cp-detail__row-icon { color: var(--txt-4); flex-shrink: 0; display: flex; align-items: center; }
.cp-detail__row-lbl  { color: var(--txt-3); font-weight: 600; min-width: 68px; flex-shrink: 0; font-size: 12px; }
.cp-detail__row-val  { color: var(--txt-2); flex: 1; text-align: right; word-break: break-all; font-size: 12px; }

.cp-result {
  display: inline-block;
  font-weight: 800;
  color: #ffffff;
  background: var(--primary);
  padding: 6px 10px;
  border-radius: 999px;
  box-shadow: 0 4px 10px rgba(252,112,16,0.12);
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}
.cp-result--badge {
  background: transparent;
  color: inherit;
  box-shadow: none;
  padding: 0;
  font-weight: 800;
}

.cp-detail__row-val--badge {
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  border: 1px solid transparent;
}
.cp-badge--huesped {
  color: #0369a1;
  background: #e0f2fe;
  border-color: #bae6fd;
}
.cp-badge--anfitrion {
  color: #15803d;
  background: #dcfce7;
  border-color: #bbf7d0;
}
.cp-badge--unknown {
  color: var(--txt-4);
  background: var(--bg-2);
  border-color: var(--border-str);
}

/* ── Separador datos bancarios ───────────────────── */
.cp-bank-sep {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 10px 0 6px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--txt-4);
  border-top: 1px solid var(--border);
  margin-top: 4px;
}
.cp-detail__rows--bank { margin-top: 4px; }

.cp-bank-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 12px;
  color: var(--txt-4);
}


/* ══ ESTADOS ═══════════════════════════════════════ */
.cp-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--txt-4);
  font-size: 13px;
  padding: 24px;
}
.cp-state--error { color: var(--red); }

.cp-spinner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2.5px solid #ECEAE4;
  border-top-color: var(--primary);
  animation: cp-spin 0.75s linear infinite;
}
@keyframes cp-spin { to { transform: rotate(360deg); } }

/* ══ TRANSICIONES ══════════════════════════════════ */
.cp-fade-enter-active,
.cp-fade-leave-active { transition: opacity 0.18s ease, transform 0.18s ease; }
.cp-fade-enter { opacity: 0; transform: scale(0.97) translateY(6px); }
.cp-fade-leave-to   { opacity: 0; transform: scale(0.97) translateY(6px); }

.cp-fade-quick-enter-active,
.cp-fade-quick-leave-active { transition: opacity 0.1s; }
.cp-fade-quick-enter,
.cp-fade-quick-leave-to { opacity: 0; }

.cp-slide-enter-active,
.cp-slide-leave-active { transition: opacity 0.15s ease, transform 0.15s ease; }
.cp-slide-enter { opacity: 0; transform: translateX(8px); }
.cp-slide-leave-to   { opacity: 0; transform: translateX(-8px); }

* { scrollbar-width: thin; scrollbar-color: #ECEAE4 transparent; }

/* ═══════════════════════════════════════════════════════════════
   RESPONSIVE — el popup flotante pasa a pantalla completa en móvil
   (sobre-escribe el left/top/width/height inline con !important)
════════════════════════════════════════════════════════════════ */
@media (max-width: 640px) {
  .cp-popup {
    left: 0 !important;
    top: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    height: 100dvh !important;
    max-width: 100vw;
    border-radius: 0 !important;
  }
  /* Sin arrastrar ni redimensionar con el dedo */
  .cp-resize { display: none !important; }
  .cp-header { cursor: default; }
}
</style>